import { render, staticRenderFns } from "./FeaturedEvent.vue?vue&type=template&id=8b228c68&"
import script from "./FeaturedEvent.vue?vue&type=script&lang=js&"
export * from "./FeaturedEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports